import moment from 'moment-timezone';
var TIMEZONE = process.env.TZ || 'Australia/Sydney';
var ListedDateType = {
  TODAY: {
    name: 'TODAY',
    offsetStart: 0,
    offsetEnd: 0,
    offsetUnit: 'days',
    labelTemplate: 'Today%date',
    labelDateFormat: ', D MMMM' // eg. "1 January"
  },
  YESTERDAY: {
    name: 'YESTERDAY',
    offsetStart: -1,
    offsetEnd: -1,
    offsetUnit: 'days',
    labelTemplate: 'Yesterday%date',
    labelDateFormat: ', D MMMM' // eg. "1 January"
  },
  WITHIN_LAST_WEEK: {
    name: 'WITHIN_LAST_WEEK',
    offsetStart: -7,
    offsetEnd: 0,
    offsetUnit: 'days',
    labelTemplate: 'Within the last week'
  },
  SPECIFIC_DATE: {
    name: 'SPECIFIC_DATE',
    labelTemplate: '%date',
    labelDateFormat: 'dddd, D MMMM' // eg. "Monday, 1 January"
  }
};
var momentFormatter = (offset, offsetUnit, format, dateOverride) => {
  if (format) {
    var instance;
    if (offsetUnit) {
      instance = moment().tz(TIMEZONE).add(offset, offsetUnit);
    } else if (dateOverride) {
      instance = moment.tz(dateOverride, TIMEZONE);
    }
    return instance && instance.isValid() ? instance.format(format) : '';
  }
  return '';
};
var getDateTypeLabel = function getDateTypeLabel(listedDateType, dateOverride) {
  var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : momentFormatter;
  if (listedDateType && listedDateType.labelTemplate) {
    var label = listedDateType.labelTemplate;
    if (label.includes('%date')) {
      var formattedDate = formatter(listedDateType.offsetStart, listedDateType.offsetUnit, listedDateType.labelDateFormat, dateOverride) || '';
      label = label.replace('%date', formattedDate);
    }
    return label.trim();
  }
  return undefined;
};
export default ListedDateType;
export { getDateTypeLabel, TIMEZONE };